import { render, staticRenderFns } from "./SplitPills.vue?vue&type=template&id=6bee3f8d&"
import script from "./SplitPills.vue?vue&type=script&lang=js&"
export * from "./SplitPills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports